import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { getadminInfoAction } from "../../../../redux/reducer/getAdminInfo/action/action";
import { Navbar, Nav } from "rsuite";
import HomeIcon from "@rsuite/icons/legacy/Home";
import CogIcon from "@rsuite/icons/legacy/Cog";

import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  IconButton,
  Button,
} from "@chakra-ui/react";



import "./adminNav.css";
import Deldb from "../deldb/deldb";

const AdmiNav = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const getAdminInfo = useSelector((info) => info);
  const [admingInfo,setAdminInfo]=useState({})
  useEffect(() => {
    axios
      .get("/getadmininfo/admin/api")
      .then(function (response) {
        // handle success
      
        setAdminInfo(response.data.data)
      })
      .catch(function (error) {
        navigate("/admin");
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }, []);

  const logoutAdmin = () => {
    axios
      .get("/logoutAdmin/api")
      .then(function (response) {
        sessionStorage.clear();
        window.location.replace("/admin");
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  };





  return (
    <>
      <div className="navCont">
        <Navbar>
          <Navbar.Brand onClick={() => navigate("/adminPage")}>
            УПРОСТИ
          </Navbar.Brand>
          <Nav>
            <Nav.Item
              icon={<HomeIcon />}
              onClick={() => navigate("/adminPage")}
            >
              Главное меню
            </Nav.Item>
            <Nav.Item>News</Nav.Item>
            <Nav.Item>Products</Nav.Item>
            <Nav.Menu title="About">
              <Nav.Item>Company</Nav.Item>
              <Nav.Item>Team</Nav.Item>
              <Nav.Menu title="Contact">
                <Nav.Item>Via email</Nav.Item>
                <Nav.Item>Via telephone</Nav.Item>
              </Nav.Menu>
            </Nav.Menu>
          </Nav>
          <div className="toggleNav">
            <Nav pullRight>
              <Nav.Menu title="Настройки" icon={<CogIcon />}>
                <Nav.Item > {admingInfo.tel}</Nav.Item>
                <Nav.Item onClick={() => navigate("allcompany")}> Компании</Nav.Item>
                <Nav.Item onClick={() => navigate("allusers")}>Пользователи</Nav.Item>
                <Nav.Item onClick={() => navigate("alladmin")}>Добавить нового администратора</Nav.Item>
                <Nav.Item onClick={() => navigate("myadmindata")}>Мои данные</Nav.Item>
                {
                  (admingInfo.tel == "37444300365")?
                  <Nav.Item > <Deldb /> </Nav.Item>
                  :
                 ""
                }
               
                  
                 
                 
                  
                <Nav.Item onClick={logoutAdmin}>Выйти</Nav.Item>
              </Nav.Menu>
            </Nav>
          </div>
        </Navbar>
        <div className="Outlet">
          <Outlet />
        </div>
      </div>

      {/* Nav for mobile cont====================================================================================== */}
      <div className="mobileCont">
        <Navbar>
          <Navbar.Brand onClick={() => navigate("/adminPage")}>УПРОСТИ</Navbar.Brand>

          <div className="toggleNav">
            <Menu>
              <MenuButton as={Button}
                
              >
                <span className="material-symbols-outlined">menu</span>
              </MenuButton>
              <MenuList>
                
                <MenuItem onClick={() => navigate("allcompany")}>Компании</MenuItem>
                <MenuItem onClick={() => navigate("allusers")}>Пользователи</MenuItem>
                <MenuItem onClick={() => navigate("alladmin")}>Добавить нового администратора</MenuItem>
                <MenuItem onClick={() => navigate("myadmindata")}>Мои данные</MenuItem>
                <MenuItem>Delete</MenuItem>
                <MenuItem onClick={logoutAdmin}>Выйти</MenuItem>
              </MenuList>
            </Menu>
          </div>
        </Navbar>

        <div className="Outlet">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AdmiNav;
